import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { PracticeTemplatesQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { PracticeTemplatesQueryResultFragment, PracticeTemplatesQueryParams } from '@docpace/manager-graphql'

const typedPracticeTemplatesQueryDocument = PracticeTemplatesQueryDocument as TypedDocumentNode<PracticeTemplatesQueryResultFragment, Partial<PracticeTemplatesQueryParams>>

export function usePracticeTemplatesQuery(opts?: useQuery.Options<PracticeTemplatesQueryResultFragment, Partial<PracticeTemplatesQueryParams>>){
    return useQuery(typedPracticeTemplatesQueryDocument, opts)
}
